export const environment = {
  production: false,
  uat: false,
  staging: true,
  development: false,
  environment: 'staging',
  baseUrl: 'https://stg-gurugram-api.tracwater.online',
  portalId: '69d37820cc476fdd84e64e1f',
  portalTypeId: '689596ee18f8a8985a2aebc5',
};
